<template>
	<p class="hola" :title=" (getLoggedIn) ? getUsername : ' &nbsp;' ">{{ (getLoggedIn) ? username : 'a &nbsp;' }}</p>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
    data: () => {
      return { }
    },
    computed: {
    	...mapGetters(['getLoggedIn', 'getUsername']), 
    	username: function(){
    		if( this.getUsername.length > 20 ){
    			return this.getUsername.substr(0,20) + '...'
    		}else{
    			return this.getUsername;
    		}
    	}
    }
  }
	
</script>
